import { DataTexture, FloatType, NearestFilter, RGBAFormat } from 'three';

/** Texels a bone takes in a row of the pose table: its turn, and its shift. */
export const POSE_TEXELS = 2;
export const POSES_PER_TEXTURE_ROW = 4;

/**
 * The citizens' pose table as the texture their vertices are posed from (shaders/citizenSkin.glsl):
 * four poses per texture row to keep the dense table within mobile texture dimensions.
 * Each bone takes `POSE_TEXELS` texels; the file's contiguous pose order stays intact.
 */
export function citizenPoseTexture(poses: Float32Array, bones: number): DataTexture {
  const poseWidth = bones * POSE_TEXELS;
  const rows = poses.length / (poseWidth * 4);
  if (!Number.isInteger(rows) || rows < 2)
    throw new RangeError(
      `A pose table of ${String(poses.length)} numbers is not rows of ${String(bones)} bones`
    );
  const width = poseWidth * POSES_PER_TEXTURE_ROW;
  const height = Math.ceil(rows / POSES_PER_TEXTURE_ROW);
  const data = poses.length === width * height * 4 ? poses : new Float32Array(width * height * 4);
  if (data !== poses) data.set(poses);
  const texture = new DataTexture(data, width, height, RGBAFormat, FloatType);
  texture.minFilter = texture.magFilter = NearestFilter;
  texture.generateMipmaps = false;
  texture.needsUpdate = true;
  return texture;
}
